import type { AgentCategoryId } from '../types/platform'

/** Homepage "Meet the agents" groups, by the work they do. */
export const AGENT_GROUPS: { category: AgentCategoryId; title: string; description: string; examples: string[] }[] = [
  {
    category: 'intake',
    title: 'Intake',
    description: 'Collect applications, forwarded emails, files, and data-room materials.',
    examples: ['Web Application', 'Email Intake', 'Data Room'],
  },
  {
    category: 'qualification',
    title: 'Qualification',
    description: 'Classify submissions and score fit against requirements.',
    examples: ['Industry Classification', 'Requirements Fit', 'Scoring'],
  },
  {
    category: 'enrichment',
    title: 'Enrichment',
    description: 'Fill information gaps and surface missing evidence.',
    examples: ['Research', 'Gap Analysis', 'Verification'],
  },
  {
    category: 'communication',
    title: 'Communication',
    description: 'Request clarification and supporting documents.',
    examples: ['Information Request', 'Follow Up', 'Stakeholder Update'],
  },
  {
    category: 'workflow',
    title: 'Workflow and reporting',
    description: 'Coordinate review steps and populate the team’s document templates.',
    examples: ['Routing', 'Approval', 'Custom Template'],
  },
  {
    category: 'monitoring',
    title: 'Monitoring',
    description: 'Track updates and milestones after a decision.',
    examples: ['Company Update', 'Grant Milestone', 'Risk Change'],
  },
]
